import { render, staticRenderFns } from "./aprova.vue?vue&type=template&id=3fe61260&scoped=true&"
import script from "./aprova.vue?vue&type=script&lang=js&"
export * from "./aprova.vue?vue&type=script&lang=js&"
import style0 from "./aprova.vue?vue&type=style&index=0&id=3fe61260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe61260",
  null
  
)

export default component.exports